"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmbClientOrderContainerType = exports.SmbClientOrderContainerSize = void 0;
var SmbClientOrderContainerSize;
(function (SmbClientOrderContainerSize) {
    SmbClientOrderContainerSize["INVALID"] = "INVALID";
    SmbClientOrderContainerSize["TWENTY_FT"] = "TWENTY_FT";
    SmbClientOrderContainerSize["TWENTY_FT_HC"] = "TWENTY_FT_HC";
    SmbClientOrderContainerSize["FORTY_FT"] = "FORTY_FT";
    SmbClientOrderContainerSize["FORTY_FT_HC"] = "FORTY_FT_HC";
    SmbClientOrderContainerSize["FORTY_FIVE_FT_HC"] = "FORTY_FIVE_FT_HC";
    SmbClientOrderContainerSize["FORTY_EIGHT_FT"] = "FORTY_EIGHT_FT";
    SmbClientOrderContainerSize["FORTY_EIGHT_FT_HC"] = "FORTY_EIGHT_FT_HC";
    SmbClientOrderContainerSize["FIFTY_THREE_FT"] = "FIFTY_THREE_FT";
    SmbClientOrderContainerSize["FIFTY_THREE_FT_HC"] = "FIFTY_THREE_FT_HC";
})(SmbClientOrderContainerSize = exports.SmbClientOrderContainerSize || (exports.SmbClientOrderContainerSize = {}));
var SmbClientOrderContainerType;
(function (SmbClientOrderContainerType) {
    SmbClientOrderContainerType["INVALID"] = "INVALID";
    SmbClientOrderContainerType["DRY"] = "DRY";
    SmbClientOrderContainerType["FLAT_RACK"] = "FLAT_RACK";
    SmbClientOrderContainerType["HEADLOAD"] = "HEADLOAD";
    SmbClientOrderContainerType["OPEN"] = "OPEN";
    SmbClientOrderContainerType["REEFER"] = "REEFER";
    SmbClientOrderContainerType["TANK"] = "TANK";
    SmbClientOrderContainerType["VENTILATED"] = "VENTILATED";
    SmbClientOrderContainerType["BULK"] = "BULK";
    SmbClientOrderContainerType["SPECIAL"] = "SPECIAL";
})(SmbClientOrderContainerType = exports.SmbClientOrderContainerType || (exports.SmbClientOrderContainerType = {}));
//# sourceMappingURL=SMBClientOrderData.js.map